import React, { useState, useEffect } from "react";

const AutoComplete = ({
  fetchData,
  onSelect,
  onAdd,
  txtLabel,
  initialValue,
  disabled,
}) => {
  const [query, setQuery] = useState(initialValue?.label || "");
  const [selectedItem, setSelectedItem] = useState(initialValue || null);
  const [results, setResults] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (initialValue?.label !== query) {
      setQuery(initialValue?.label || "");
      setSelectedItem(initialValue || null);
    }
  }, [initialValue]);

  useEffect(() => {
    if (query.trim() === "") {
      setResults([]);
      setShowDropdown(false);
      setSelectedItem(null);
      if (selectedItem !== null) {
        onSelect(null);
      }
      return;
    }

    if (selectedItem && selectedItem.label === query) {
      setShowDropdown(false);
      return;
    }

    const timeout = setTimeout(async () => {
      const data = await fetchData(query);
      setResults(data);
      setShowDropdown(data.length > 0);
    }, 300);

    return () => clearTimeout(timeout);
  }, [query]);

  const handleSelect = (item) => {
    setQuery(item.label);
    setSelectedItem(item);
    setShowDropdown(false);
    onSelect(item);
  };

  return (
    <div className="autocomplete-wrapper">
      <div className="form-floating">
        <input
          disabled={disabled}
          type="text"
          className="form-control"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setShowDropdown(results.length > 0)}
          placeholder="Buscar..."
        />
        <label>{txtLabel}</label>

        {results.length === 0 && query.trim() !== "" && !selectedItem && (
          <button
            type="button"
            className="btn btn-primary autocomplete-add"
            onClick={onAdd}
          >
            +
          </button>
        )}
      </div>

      {showDropdown && (
        <ul className="autocomplete-dropdown">
          {results.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoComplete;